import TiptapImage from '@tiptap/extension-image';
import { mergeAttributes, VueNodeViewRenderer } from '@tiptap/vue-3';
import EditorResizableImage from 'components/Editor/EditorResizableImage.vue';
import { FILES_TO_UPLOAD_ATTR, LOCAL_FILES_ATTR } from 'src/utils/OfflineAccessUtils';

const DEFAULT_WIDTH = 600;

export default TiptapImage.extend({
  addOptions() {
    return {
      allowBase64: false,
      defaultWidth: DEFAULT_WIDTH,
    };
  },

  addAttributes() {
    return {
      width: {
        default: this.options.defaultWidth > 0 ? this.options.defaultWidth : DEFAULT_WIDTH,
      },

      group: 'inline',

      draggable: true,

      display: 'block',

      src: this.src,

      failToFetch: {
        default: false,
      },

      unsupportedImageType: {
        default: false,
      },

      [LOCAL_FILES_ATTR]: {
        default: null,
      },

      [FILES_TO_UPLOAD_ATTR]: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [{ tag: 'img[src]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['img', mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return VueNodeViewRenderer(EditorResizableImage);
  },
});
